/* eslint-disable */
import React, { Component } from "react";
import { FormControl, HStack } from "@chakra-ui/react";
import { connect } from "react-redux";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { connectModal } from "redux-modal";
import IconButton from "@material-ui/core/IconButton";
import CancelIcon from "@material-ui/icons/Cancel";
import { withTranslation } from "react-i18next";

import { addFundPart, getFund } from "../../utils/store/actions/funds.actions";
import { Card, CardContent } from "@material-ui/core";
import { B4FText } from "../component-questionnaire/B4FFields/B4FText";
import { B4FRadio } from "../component-questionnaire/B4FFields/B4FRadio";
import { B4FNumber } from "../component-questionnaire/B4FFields/B4FNumber";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";

const styles = (theme: Theme) =>
  createStyles({
    fundCards: {
      borderRadius: "12px",
      maxWidth: "1200px",
      margin: "0 auto",
      display: "grid",
      gridGap: "1rem",
      [theme.breakpoints.up("lg")]: {
        gridTemplateColumns: "repeat(2, 1fr)",
      },
      [theme.breakpoints.up("xl")]: {
        gridTemplateColumns: "repeat(3, 1fr)",
      },
    },
    card: {
      borderRadius: "12px",
      margin: "1%",
    },
  });
class ModalFundAddParts extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      part: {
        id: "",
        name: "",
        partIsin: "",
        isPartOpenToUsInvestorPerson: "",
        isPartOpenToEligibleCounterParty: "",
        isPartOpenToCanadianInvestor: "",
        isOpenToNonProfessionalInvestor: "",
        visibleForExternalSales:""
      },
    };
  }
  handleAddPart = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const fundPersonId = urlParams.get("id");
    this.props.addFundPart(this.state.part, fundPersonId).then(() => {
      this.props.getFund();
    });
  };

  render() {
    const { show, handleHide, t, classes } = this.props;
    const closeBtn = (
      <IconButton className="close" onClick={handleHide}>
        <CancelIcon />
      </IconButton>
    );
    return (
      <Modal
        isOpen={show}
        toggle={handleHide}
        backdrop={true}
        style={{
          backgroundColor: "#f5f6ff",
          maxWidth: "fit-content",
        }}
      >
        <ModalHeader
          toggle={handleHide}
          close={closeBtn}
          style={{
            backgroundColor: "#f5f6ff",
          }}
        >
          {t("CREATE_PART")}
        </ModalHeader>

        <ModalBody
          style={{
            backgroundColor: "#f5f6ff",
          }}
        >
          <div style={{ margin: "1%", fontWeight: "bolder" }}>
            {t("INFORMATIONS")[0].toUpperCase() +
              t("INFORMATIONS").slice(1).toLowerCase()}
          </div>
          <Card className={classes.card}>
            <CardContent className={classes.fundCards}>
              <B4FText
                label="NAME"
                value={this.state.part.name}
                id="partName"
                key="partName"
                onBlur={console.log}
                placeholder=""
                onChange={(e: any) => {
                  this.setState({
                    part: {
                      ...this.state.part,
                      name: e.value,
                    },
                  });
                }}
                isRequired={true}
                visible={true}
              />
              <B4FText
                label="PART_ISIN"
                value={this.state.part.partIsin}
                onBlur={console.log}
                onChange={(e: any) => {
                  this.setState({
                    part: {
                      ...this.state.part,
                      partIsin: e.value,
                    },
                  });
                }}
                id="partIsin"
                key="partIsin"
                isRequired={true}
                isDisabled={false}
                visible={true}
              />
              <B4FRadio
                label="IS_PART_OPEN_TO_US_INVESTOR_PERSON"
                key="isPartOpenToUsInvestorPerson"
                id="isPartOpenToUsInvestorPerson"
                onChange={(e: any) => {
                  this.setState({
                    part: {
                      ...this.state.part,
                      isPartOpenToUsInvestorPerson: e.value,
                    },
                  });
                }}
                options={[
                  { label: "YES_NO.YES", key: "true" },
                  { label: "YES_NO.NO", key: "false" },
                ]}
                value={
                  this.state.part.isPartOpenToUsInvestorPerson !== null &&
                  this.state.part.isPartOpenToUsInvestorPerson.toString()
                }
                isRequired={true}
                visible={true}
              />
              <B4FRadio
                label="IS_PART_OPEN_TO_ELIGIBLE_COUNTERPARTY"
                key="isPartOpenToEligibleCounterParty"
                id="isPartOpenToEligibleCounterParty"
                onChange={(e: any) => {
                  this.setState({
                    part: {
                      ...this.state.part,
                      isPartOpenToEligibleCounterParty: e.value,
                    },
                  });
                }}
                options={[
                  { label: "YES_NO.YES", key: "true" },
                  { label: "YES_NO.NO", key: "false" },
                ]}
                value={
                  this.state.part.isPartOpenToEligibleCounterParty !== null &&
                  this.state.part.isPartOpenToEligibleCounterParty.toString()
                }
                isRequired={true}
                visible={true}
              />
              <B4FRadio
                label="IS_PART_OPEN_TO_CANADIAN_INVESTOR"
                key="isPartOpenToCanadianInvestor"
                id="isPartOpenToCanadianInvestor"
                onChange={(e: any) => {
                  this.setState({
                    part: {
                      ...this.state.part,
                      isPartOpenToCanadianInvestor: e.value,
                    },
                  });
                }}
                options={[
                  { label: "YES_NO.YES", key: "true" },
                  { label: "YES_NO.NO", key: "false" },
                ]}
                value={
                  this.state.part.isPartOpenToCanadianInvestor !== null &&
                  this.state.part.isPartOpenToCanadianInvestor.toString()
                }
                isRequired={true}
                visible={true}
              />
              <B4FRadio
                label="IS_OPEN_TO_NON_PRORESSIONAL"
                key="isOpenToNonProfessionalInvestor"
                id="isOpenToNonProfessionalInvestor"
                onChange={(e: any) => {
                  this.setState({
                    part: {
                      ...this.state.part,
                      isOpenToNonProfessionalInvestor: e.value,
                    },
                  });
                }}
                options={[
                  { label: "YES_NO.YES", key: "true" },
                  { label: "YES_NO.NO", key: "false" },
                ]}
                value={
                  this.state.part.isOpenToNonProfessionalInvestor !== null &&
                  this.state.part.isOpenToNonProfessionalInvestor.toString()
                }
                isRequired={true}
                visible={true}
              />
               <B4FRadio
                label="VISIBLE_FOR_EXTERNAL_SALES"
                key="visibleForExternalSales"
                id="visibleForExternalSales"
                onChange={(e: any) => {
                  this.setState({
                    part: {
                      ...this.state.part,
                      visibleForExternalSales: e.value,
                    },
                  });
                }}
                options={[
                  { label: "YES_NO.YES", key: "true" },
                  { label: "YES_NO.NO", key: "false" },
                ]}
                value={
                  this.state.part.visibleForExternalSales !== null &&
                  this.state.part.visibleForExternalSales.toString()
                }
                isRequired={true}
                visible={true}
              />
            </CardContent>
          </Card>
        </ModalBody>
        <ModalFooter
          style={{
            backgroundColor: "#f5f6ff",
            borderRadius: "10px",
          }}
        >
          <Button
            style={{
              color: "rgb(99, 110, 149)",
              border: "2px solid",
              background: "none",
            }}
            onClick={handleHide}
          >
            {t("CANCEL")}
          </Button>
          <Button
            style={{
              color: "white",
              backgroundColor: "#ae0064",
              textTransform: "none",
            }}
            onClick={() => {
              this.handleAddPart(), handleHide();
            }}
            disabled={
              this.state.part.name === "" ||
              this.state.part.partIsin === "" ||
              this.state.part.isPartOpenToUsInvestorPerson === "" ||
              this.state.part.isPartOpenToEligibleCounterParty === "" ||
              this.state.part.isPartOpenToCanadianInvestor === "" ||
              this.state.part.isOpenToNonProfessionalInvestor === ""
            }
          >
            {t("CREATE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}
const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  addFundPart,
  getFund,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withTranslation()(
    withStyles(styles)(
      connectModal({ name: "create_update_part" })(ModalFundAddParts)
    )
  )
);
